// Globals
import { FC, Suspense, useMemo } from 'react';

// Components
import { IFormInstance, useWatchForm } from '@/components';

// Helpers
import { getCouponTemplate, TCreateCouponFormValues } from '../../helpers';
import { StyledWrapper } from './CouponPreviewStyles';
import { Spinner } from '@/ui';

type TCouponPreviewProps = {
  formInstance: IFormInstance;
};

const CouponPreview: FC<TCouponPreviewProps> = ({ formInstance }) => {
  const fields = useWatchForm<TCreateCouponFormValues>([], formInstance);

  const TemplateComponent = useMemo(() => getCouponTemplate(fields?.templateNumber), [fields?.templateNumber]);

  if (!TemplateComponent) return;

  return (
    <StyledWrapper>
      <Suspense fallback={<Spinner spinning />}>
        <TemplateComponent {...fields} />
      </Suspense>
    </StyledWrapper>
  );
};

export default CouponPreview;
